'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import TextArea from './components/public/TextArea';
// import UsersGrid from './components/public/UsersGrid';
// import ParralaxTest from './components/public/Parallax/Test';
// import RoutedObject from './components/public/Router/RoutedObject';
// import DraftEditor from './components/public/DraftEditor';
// import TextArea from './components/public/TextArea';
// import UserPage from './components/public/pages/Users/User';
// import ChangeLanguage from './components/public/ChangeLanguage';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Close = require('material-ui-icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _ArrowForward = require('material-ui-icons/ArrowForward');

var _ArrowForward2 = _interopRequireDefault(_ArrowForward);

var _ArrowBack = require('material-ui-icons/ArrowBack');

var _ArrowBack2 = _interopRequireDefault(_ArrowBack);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _Page = require('./components/public/Page');

var _Page2 = _interopRequireDefault(_Page);

var _Grid = require('./components/public/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Connector = require('./components/public/Connectors/Connector');

var _Connector2 = _interopRequireDefault(_Connector);

var _ObjectConnector = require('./components/public/Connectors/ObjectConnector');

var _ObjectConnector2 = _interopRequireDefault(_ObjectConnector);

var _ListView = require('./components/public/Connectors/Connector/ListView');

var _ListView2 = _interopRequireDefault(_ListView);

var _ObjectView = require('./components/public/Connectors/ObjectConnector/ObjectView');

var _ObjectView2 = _interopRequireDefault(_ObjectView);

var _Pagination = require('./components/public/Connectors/Connector/Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _UserLink = require('./components/public/Connectors/Connector/UserLink');

var _UserLink2 = _interopRequireDefault(_UserLink);

var _Filters = require('./components/public/Connectors/Connector/Filters');

var _Filters2 = _interopRequireDefault(_Filters);

var _CreatedBy = require('./components/public/Connectors/Connector/Fields/CreatedBy');

var _CreatedBy2 = _interopRequireDefault(_CreatedBy);

var _NamedField = require('./components/public/Connectors/Connector/Fields/NamedField');

var _NamedField2 = _interopRequireDefault(_NamedField);

var _Content = require('./components/public/Connectors/Connector/Fields/Content');

var _Content2 = _interopRequireDefault(_Content);

var _Section = require('./components/public/Section');

var _Section2 = _interopRequireDefault(_Section);

var _Typography = require('./components/public/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Switch = require('./components/public/Router/Switch');

var _Switch2 = _interopRequireDefault(_Switch);

var _Route = require('./components/public/Router/Route');

var _Route2 = _interopRequireDefault(_Route);

var _PageHeader = require('./components/public/PageHeader');

var _PageHeader2 = _interopRequireDefault(_PageHeader);

var _Link = require('./components/public/Link');

var _Link2 = _interopRequireDefault(_Link);

var _context3 = require('./context');

var _Tag = require('./components/public/Tag');

var _Tag2 = _interopRequireDefault(_Tag);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _ObjectImage = require('./components/public/Connectors/Connector/Fields/ObjectImage');

var _ObjectImage2 = _interopRequireDefault(_ObjectImage);

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _marketplace = require('./marketplace');

var _marketplace2 = _interopRequireDefault(_marketplace);

var _Button = require('./components/public/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Query = require('./components/public/Connectors/Query');

var _Query2 = _interopRequireDefault(_Query);

var _Slider = require('./components/public/Slider');

var _Slider2 = _interopRequireDefault(_Slider);

var _Iterable = require('./components/public/Connectors/Connector/ListView/Iterable');

var _Iterable2 = _interopRequireDefault(_Iterable);

var _AppBar = require('./components/public/AppBar');

var _AppBar2 = _interopRequireDefault(_AppBar);

var _Login = require('./components/public/Login');

var _Login2 = _interopRequireDefault(_Login);

var _LanguageRouter = require('./components/public/LanguageRouter');

var _LanguageRouter2 = _interopRequireDefault(_LanguageRouter);

var _TextField = require('./components/public/form/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _EditableObject = require('./components/public/form/EditableObject');

var _EditableObject2 = _interopRequireDefault(_EditableObject);

var _EditableView = require('./components/public/form/EditableObject/EditableView');

var _EditableView2 = _interopRequireDefault(_EditableView);

var _DefaultView = require('./components/public/form/EditableObject/DefaultView');

var _DefaultView2 = _interopRequireDefault(_DefaultView);

var _VerticalTimeline = require('./components/public/VerticalTimeline');

var _VerticalTimeline2 = _interopRequireDefault(_VerticalTimeline);

var _VerticalTimelineItem = require('./components/public/VerticalTimeline/VerticalTimelineItem');

var _VerticalTimelineItem2 = _interopRequireDefault(_VerticalTimelineItem);

var _RichText = require('./components/public/RichText');

var _RichText2 = _interopRequireDefault(_RichText);

var _Table = require('./components/public/Table');

var _Table2 = _interopRequireDefault(_Table);

var _TableRow = require('./components/public/Table/TableRow');

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableCell = require('./components/public/Table/TableCell');

var _TableCell2 = _interopRequireDefault(_TableCell);

var _Tabs = require('./components/public/Tabs');

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Tab = require('./components/public/Tabs/Tab');

var _Tab2 = _interopRequireDefault(_Tab);

var _CreateObjectLink = require('./components/public/Button/CreateObjectLink');

var _CreateObjectLink2 = _interopRequireDefault(_CreateObjectLink);

var _SudoOnly = require('./components/public/SudoOnly');

var _SudoOnly2 = _interopRequireDefault(_SudoOnly);

var _EditableObjectButtons = require('./components/public/form/EditableObject/EditableObjectButtons');

var _EditableObjectButtons2 = _interopRequireDefault(_EditableObjectButtons);

var _ResetObjectContext = require('./components/public/ResetObjectContext');

var _ResetObjectContext2 = _interopRequireDefault(_ResetObjectContext);

var _DefaultValue = require('./components/public/Connectors/Connector/Fields/NamedField/DefaultValue');

var _DefaultValue2 = _interopRequireDefault(_DefaultValue);

var _CurrentUser = require('./components/public/CurrentUser');

var _CurrentUser2 = _interopRequireDefault(_CurrentUser);

var _FileUploader = require('./components/public/FileUploader');

var _FileUploader2 = _interopRequireDefault(_FileUploader);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  var _root, _editor, _panel, _panelItems;

  var breakpoints = theme.breakpoints,
      _theme$palette = theme.palette,
      _theme$palette$backgr = _theme$palette.background,
      bgDefault = _theme$palette$backgr.default,
      bgPaper = _theme$palette$backgr.paper,
      textPrimary = _theme$palette.text.primary;
  var desktop = breakpoints.up("sm");
  var dragOveredBorderColor = "#15e408";
  var hoveredBorderColor = "#7509da";
  var activeBorderColor = "#b806bb";
  var dirtyBorderColor = "red";
  var itemsPanelWidth = 290;
  return {
    root: (_root = {}, _root[desktop] = {
      flex: 1,
      display: "flex" // flexDirection: "row-reverse",

    }, _root["&.fullheight"] = {
      height: "100vh"
    }, _root),
    editor: (_editor = {
      position: "relative"
    }, _editor[desktop] = {
      flex: 1,
      overflow: "auto",
      height: "100%"
    }, _editor),
    panel: (_panel = {}, _panel[desktop] = {
      width: "min-content",
      height: "100%",
      overflow: "auto",
      position: "relative",
      transition: "width 0.5s",
      "&.templates": {
        width: 50
      },
      "&.opened": {
        width: itemsPanelWidth
      }
    }, _panel),
    panelItems: (_panelItems = {}, _panelItems[desktop] = {
      height: "100%",
      width: "100%",
      // width: itemsPanelWidth,
      // position: "absolute",
      overflow: "auto"
    }, _panelItems),
    toolbar: {// border: "1px solid blue",
    },
    panelItem: {
      cursor: "grab",
      padding: 10,
      border: "1px solid #ddd",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      "&:hover": {
        border: '1px solid ' + hoveredBorderColor
      },
      "&.active": {
        border: '1px solid ' + activeBorderColor
      },
      "&.hovered": {
        border: '1px solid ' + hoveredBorderColor
      },
      "&.dragOvered": {
        border: '1px solid ' + dragOveredBorderColor
      },
      "&.add_child": {
        cursor: "pointer"
      }
    },
    item: {},
    // inEditMode
    itemEditable: {
      position: "relative",
      minHeight: "30px",
      border: "1px dotted #ddd",
      padding: 7,
      "&.dirty": {
        border: '1px solid ' + dirtyBorderColor
      },
      "&.active": {
        border: '1px solid ' + activeBorderColor
      },
      "&.dragOvered": {
        border: '1px solid ' + dragOveredBorderColor
      },
      "&.hovered": {
        border: '1px solid ' + hoveredBorderColor
      },
      "&.root": {
        borderWidth: 2
      },
      "&.disabled": {
        borderColor: "transparent"
      },
      // https://habr.com/ru/post/456248/
      "&[contenteditable=true]": {
        "&:empty:before": {
          content: "unset"
        }
      }
    },
    blockBadge: {
      border: "1px solid #ddd",
      position: "absolute",
      bottom: "100%",
      right: 0,
      zIndex: "2000",
      background: bgDefault,
      color: textPrimary,
      padding: 3
    },
    badgeButton: {
      height: 34,
      width: 34
    },
    panelButton: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    },
    bordered: {
      border: "1px solid #ddd"
    },
    helpLink: {
      color: "inherit",
      marginLeft: 3
    },
    actionPanel: {
      borderTop: "1px solid #ddd",
      maxHeight: 250,
      overflow: "auto"
    }
  };
};

var FrontEditor = (_temp = _class = function (_Component) {
  _inherits(FrontEditor, _Component);

  function FrontEditor(props) {
    _classCallCheck(this, FrontEditor);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      /**
       * Элемент в панели управления, который может быть перетянут на страницу
       */
      dragItem: null,

      /**
       * Текущий элемент на странице, в который может быть заброшен новый элемент
       */
      dragTarget: null,

      /**
       * Текущий элемент на странице, свойства которого можно редактировать (выбирается по клику)
       */
      activeItem: null,

      /**
       * Элемент, на который наведена мышь
       */
      hoveredItem: null,
      Components: _this.prepareComponents(),

      /**
       * Открыта ли панель с каталогом шаблонов
       */
      templatesOpened: false
    };
    return _this;
  }

  FrontEditor.prototype.initContext = function initContext() {
    var _this2 = this;
    /**
     * Этот массив используется для быстрого поиска всех отрендеренных компонентов
     */


    this.mountedComponents = []; // const {
    //   inEditMode = true,
    // } = this.state;

    var _props = this.props,
        classes = _props.classes,
        inEditMode = _props.inEditMode;
    var Components = this.getComponents();
    var editorContext = {
      inEditMode: inEditMode,
      classes: classes,
      // components,
      updateObject: function updateObject(data) {
        return _this2.updateObject(data);
      },
      // dragItem,
      getDragItem: function getDragItem() {
        var dragItem = _this2.state.dragItem;
        return dragItem;
      },
      // dragTarget,
      getDragTarget: function getDragTarget() {
        var dragTarget = _this2.state.dragTarget;
        return dragTarget;
      },
      // activeItem,
      getActiveItem: function getActiveItem() {
        var activeItem = _this2.state.activeItem;
        return activeItem;
      },
      // hoveredItem,
      getHoveredItem: function getHoveredItem() {
        var hoveredItem = _this2.state.hoveredItem;
        return hoveredItem;
      },
      // settingsViewContainer,
      getSettingsViewContainer: function getSettingsViewContainer() {
        return _this2.settingsViewContainer;
      },
      onDragStart: function onDragStart(event, item) {
        // this.setState({
        //   dragItem: item,
        // });
        _this2.updateContext({
          dragItem: item
        });
      },
      onDragEnd: function onDragEnd(item) {
        // this.setState({
        //   dragItem: null,
        //   dragTarget: null,
        //   activeItem: null,
        //   hoveredItem: null,
        // });
        _this2.updateContext({
          dragItem: null,
          dragTarget: null,
          activeItem: null,
          hoveredItem: null
        });
      },
      setDragTarget: function setDragTarget(component) {
        _this2.setState({
          dragTarget: component
        });

        _this2.updateContext({
          dragTarget: component
        });
      },
      setActiveItem: function setActiveItem(component) {
        // this.setState({
        //   activeItem: component,
        // });
        if (component) {
          component.setState({
            active: true
          });
        }

        var components = _this2.mountedComponents.filter(function (n) {
          return n.state.active && (!component || n !== component);
        });

        components.map(function (n) {
          return n.setState({
            active: false
          });
        });

        _this2.updateContext({
          activeItem: component
        }); // this.forceUpdate();

      },
      setHoveredItem: function setHoveredItem(component) {
        // this.setState({
        //   activeItem: component,
        // });
        if (component) {
          component.setState({
            hovered: true
          });
        }

        var components = _this2.mountedComponents.filter(function (n) {
          return n.state.hovered && (!component || n !== component);
        });

        components.map(function (n) {
          return n.setState({
            hovered: false
          });
        });
      },
      // setHoveredItem: component => {
      //   // this.setState({
      //   //   hoveredItem: component,
      //   // });
      //   this.setState({
      //     hoveredItem: component,
      //   });
      // },
      Components: Components,
      forceUpdate: function forceUpdate() {
        _this2.forceUpdate();
      },
      TemplateRenderer: this.TemplateRenderer,
      // actionPanel: this.actionPanel,
      getActionPanel: function getActionPanel() {
        return _this2.actionPanel;
      },
      registerMountedComponent: function registerMountedComponent(component) {
        // const {
        //   inEditMode,
        // } = this.props;
        // if (inEditMode) {
        var mode = component.props.mode;

        if (mode === "main") {
          _this2.mountedComponents.push(component);
        } // }

      },
      unregisterMountedComponent: function unregisterMountedComponent(component) {
        var index = _this2.mountedComponents.indexOf(component);

        if (index !== -1) {
          _this2.mountedComponents.splice(index, 1);
        }
      }
    };
    this.state.editorContext = editorContext;
  };

  FrontEditor.prototype.updateContext = function updateContext(data) {
    var editorContext = this.state.editorContext;
    this.setState({
      editorContext: _extends({}, editorContext, data)
    });
  };

  FrontEditor.prototype.getContextValue = function getContextValue(name) {
    var value = this.state.editorContext[name];
    return value;
  };

  FrontEditor.prototype.componentWillMount = function componentWillMount() {
    var _ref = this.context.query || {},
        _ref$template = _ref.template,
        template = _ref$template === undefined ? '\n      query template($where: TemplateWhereUniqueInput!) {\n        object: template(where: $where) {\n          ...Template\n        }\n      }\n      \n      fragment Template on Template {\n        ...TemplateNoNesting\n        CreatedBy {\n          ...UserNoNesting\n        }\n        PrismaProject {\n          ...ProjectNoNesting\n        }\n        \n      }\n      \n      fragment TemplateNoNesting on Template {\n        id\n        createdAt\n        updatedAt\n        externalKey\n        name\n        description\n        component\n        props\n        components\n        rank\n        vars\n      }\n      \n      fragment UserNoNesting on User {\n        id\n        username\n        fullname\n        image\n      }\n      \n      fragment ProjectNoNesting on Project {\n        id\n        createdAt\n        updatedAt\n        name\n        description\n        url\n        domain\n      }\n      ' : _ref$template;

    this.TemplateRenderer = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(template))(function (options) {
      var Component = options.Component,
          where = options.where,
          other = _objectWithoutProperties(options, ['Component', 'where']);

      var object = other.object,
          data = other.data;
      object = object !== undefined ? object : data && data.object || null; // console.log("TemplateRenderer props", JSON.stringify(this.props, true, 2));

      if (!object) {
        return null;
      }

      var _object = object,
          templateId = _object.id,
          props = _object.props,
          components = _object.components;
      return _react2.default.createElement(Component, _extends({
        key: templateId // mode="main"
        // // component={n}
        // parent={this}
        // // props={props}
        // data={{
        //   object: n,
        // }}
        // // _dirty={n}
        ,
        object: object,
        props: props,
        components: components
      }, other));
    });
    this.initContext();
    _Component.prototype.componentWillMount && _Component.prototype.componentWillMount.call(this);
  };

  FrontEditor.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var inEditMode = this.props.inEditMode;

    if (inEditMode !== undefined && inEditMode !== prevProps.inEditMode) {
      var editorContext = this.state.editorContext;
      this.setState({
        editorContext: _extends({}, editorContext, {
          inEditMode: inEditMode
        })
      });
    }

    _Component.prototype.componentDidUpdate && _Component.prototype.componentDidUpdate.call(this, prevProps, prevState);
  };

  FrontEditor.prototype.prepareComponents = function prepareComponents() {
    var _props2 = this.props,
        Components = _props2.Components,
        CustomComponents = _props2.CustomComponents;
    var baseComponents = [_Page2.default].concat(Components).filter(function (n) {
      return n && !CustomComponents.find(function (i) {
        return i.Name === n.Name;
      });
    });
    return baseComponents.concat(CustomComponents).filter(function (n) {
      return n && n.Name;
    });
  };

  FrontEditor.prototype.renderPanels = function renderPanels() {
    var _this3 = this;

    var Grid = this.context.Grid;
    var classes = this.props.classes;
    var Components = this.getComponents();
    return _react2.default.createElement('div', {
      className: classes.panelItems
    }, _react2.default.createElement(Grid, {
      container: true,
      spacing: 8
    }, Components.map(function (Component) {
      var name = Component.Name;
      return _react2.default.createElement(Component, {
        key: name,
        mode: 'panel',
        className: classes.panelItem
      });
    }), _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement('div', {
      ref: function ref(el) {
        _this3.settingsViewContainer = el;
      }
    }))));
  };

  FrontEditor.prototype.renderTemplates = function renderTemplates() {
    var _this4 = this;

    var Grid = this.context.Grid;
    var _state = this.state,
        templatesGroup = _state.templatesGroup,
        templatesOpened = _state.templatesOpened;
    var activeItem = this.getContextValue("activeItem");

    var _props3 = this.props,
        data = _props3.data,
        _dirty = _props3._dirty,
        classes = _props3.classes,
        other = _objectWithoutProperties(_props3, ['data', '_dirty', 'classes']);

    var content = void 0;

    if (activeItem) {
      content = _react2.default.createElement('div', {
        style: {
          position: "relative",
          // border: "1px solid red",
          height: "100%",
          display: "flex",
          flexDirection: "column"
        }
      }, _react2.default.createElement('div', null, _react2.default.createElement(_IconButton2.default, {
        onClick: function onClick(event) {
          _this4.setState({
            templatesOpened: !templatesOpened
          });
        }
      }, templatesOpened ? _react2.default.createElement(_ArrowBack2.default, null) : _react2.default.createElement(_ArrowForward2.default, null))), templatesOpened ? _react2.default.createElement(_marketplace2.default, {
        classes: classes,
        activeItem: activeItem,
        FrontEditor: FrontEditorRenderer
      }) : null);
    }

    return _react2.default.createElement('div', {
      className: [classes.panel, classes.bordered, "templates", templatesOpened ? "opened" : ""].join(" ")
    }, content); // if (templatesOpened) {
    // }
    // else {
    //   return <IconButton
    //     onClick={event => {
    //       this.setState({
    //         templatesOpened: !templatesOpened,
    //       })
    //     }}
    //   >
    //     <OpenTemplatesIcon
    //     />
    //   </IconButton>
    // }
  };

  FrontEditor.prototype.renderTemplates__ = function renderTemplates__() {
    var _this5 = this;

    var Grid = this.context.Grid;
    var _state2 = this.state,
        activeItem = _state2.activeItem,
        templatesGroup = _state2.templatesGroup;

    if (!activeItem) {
      return null;
    }

    var _props4 = this.props,
        data = _props4.data,
        _dirty = _props4._dirty,
        other = _objectWithoutProperties(_props4, ['data', '_dirty']);

    var templates = this.getTemplates(); // let components;

    var list = templates.map(function (n, index) {
      var label = n.label,
          templates = n.templates;
      return _react2.default.createElement('div', {
        key: index,
        style: {
          padding: 10,
          margin: "5px 0",
          cursor: "pointer",
          borderTop: "1px solid #ddd",
          borderBottom: "1px solid #ddd"
        },
        onClick: function onClick(event) {
          _this5.setState({
            templatesGroup: templates // templatesGroup: templatesGroup && templatesGroup === templates ? null : templates,

          });
        }
      }, label);
    });
    return _react2.default.createElement('div', {
      style: {
        position: "relative",
        // border: "1px solid red",
        height: "100%"
      }
    }, list, templatesGroup && templatesGroup.length ? _react2.default.createElement('div', {
      style: {
        position: "absolute",
        // border: "1px solid blue",
        left: "100%",
        top: 0,
        height: "100%",
        width: "490px",
        padding: 15,
        zIndex: 1200,
        background: "rgba(255, 255, 255, 1)",
        overflowY: "auto"
      }
    }, _react2.default.createElement(Grid, {
      container: true
    }, _react2.default.createElement(Grid, {
      item: true,
      xs: true
    }), _react2.default.createElement(Grid, {
      item: true
    }, _react2.default.createElement(_IconButton2.default, {
      onClick: function onClick(event) {
        _this5.closeTemplates();
      }
    }, _react2.default.createElement(_Close2.default, null)))), templatesGroup.map(function (n, index) {
      var label = n.label,
          component = _objectWithoutProperties(n, ['label']);

      return _react2.default.createElement('div', {
        key: index,
        style: {
          position: "relative",
          borderBottom: index - 1 === templatesGroup.length ? undefined : "1px solid #ddd",
          margin: "30px 0",
          cursor: "pointer"
        },
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();

          if (activeItem) {
            activeItem.addComponent(component);
          }

          _this5.closeTemplates();
        }
      }, _react2.default.createElement('h3', {
        style: {
          borderBottom: "2px solid #ddd"
        }
      }, label), _react2.default.createElement(FrontEditor, _extends({}, other, {
        inEditMode: false,
        data: {
          object: component
        }
      })));
    })) : null);
  };

  FrontEditor.prototype.closeTemplates = function closeTemplates() {
    this.setState({
      templatesGroup: null
    });
  };

  FrontEditor.prototype.getTemplates = function getTemplates() {
    var customTemplates = this.props.templates;
    var templates = [];
    templates.push({
      label: "Разметка",
      templates: this.getGridTemplates()
    });
    templates.push({
      label: "Текстовый блок",
      templates: this.getTextTemplates()
    });
    templates.push({
      label: "Меню",
      templates: this.getMenuTemplates()
    });
    templates.push({
      label: "Данные сайта",
      templates: this.getDataTemplates()
    });
    templates.push({
      label: "Медиа",
      templates: this.getMediaTemplates()
    });
    return templates.concat(customTemplates || []);
  };

  FrontEditor.prototype.getGridTemplates = function getGridTemplates() {
    var buttons = [];
    buttons.push({
      name: "Section",
      label: "Основной блок",
      props: {},
      components: [{
        name: "Section",
        props: {
          style: {
            margin: "0 auto",
            maxWidth: "1260px"
          }
        },
        components: [{
          name: "Section",
          props: {
            style: {
              paddingTop: "100px",
              paddingBottom: "100px"
            }
          },
          components: [{
            name: "Tag",
            props: {
              tag: "div"
            },
            components: [{
              name: "Tag",
              props: {
                text: "Lorem Ipsum \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0439 \"\u0440\u044B\u0431\u043E\u0439\" \u0434\u043B\u044F \u0442\u0435\u043A\u0441\u0442\u043E\u0432 \u043D\u0430 \u043B\u0430\u0442\u0438\u043D\u0438\u0446\u0435 \u0441 \u043D\u0430\u0447\u0430\u043B\u0430 XVI \u0432\u0435\u043A\u0430. \u0412 \u0442\u043E \u0432\u0440\u0435\u043C\u044F \u043D\u0435\u043A\u0438\u0439 \u0431\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439 \u043F\u0435\u0447\u0430\u0442\u043D\u0438\u043A \u0441\u043E\u0437\u0434\u0430\u043B \u0431\u043E\u043B\u044C\u0448\u0443\u044E \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044E \u0440\u0430\u0437\u043C\u0435\u0440\u043E\u0432 \u0438 \u0444\u043E\u0440\u043C \u0448\u0440\u0438\u0444\u0442\u043E\u0432, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F Lorem Ipsum \u0434\u043B\u044F \u0440\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u043A\u0438 \u043E\u0431\u0440\u0430\u0437\u0446\u043E\u0432. Lorem Ipsum \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u0436\u0438\u043B \u0431\u0435\u0437 \u0437\u0430\u043C\u0435\u0442\u043D\u044B\u0445 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u043F\u044F\u0442\u044C \u0432\u0435\u043A\u043E\u0432, \u043D\u043E \u0438 \u043F\u0435\u0440\u0435\u0448\u0430\u0433\u043D\u0443\u043B \u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u0434\u0438\u0437\u0430\u0439\u043D."
              },
              components: []
            }]
          }]
        }]
      }]
    });
    buttons.push({
      name: "Tag",
      label: "Таблица",
      props: {
        tag: "div"
      },
      components: [{
        name: "Tag",
        props: {
          tag: "table",
          style: {
            width: "100%"
          }
        },
        components: [{
          name: "Tag",
          props: {
            tag: "tbody"
          },
          components: [{
            name: "Tag",
            props: {
              tag: "tr"
            },
            components: [{
              name: "Tag",
              props: {
                tag: "th"
              },
              components: [{
                name: "Tag",
                props: {
                  text: "th"
                },
                components: []
              }]
            }, {
              name: "Tag",
              props: {
                tag: "td"
              },
              components: [{
                name: "Tag",
                props: {
                  text: "td"
                },
                components: []
              }]
            }]
          }, {
            name: "Tag",
            props: {
              tag: "tr"
            },
            components: [{
              name: "Tag",
              props: {
                tag: "th"
              },
              components: [{
                name: "Tag",
                props: {
                  text: "th"
                },
                components: []
              }]
            }, {
              name: "Tag",
              props: {
                tag: "td"
              },
              components: [{
                name: "Tag",
                props: {
                  text: "td"
                },
                components: []
              }]
            }]
          }]
        }]
      }]
    });
    return buttons;
  };

  FrontEditor.prototype.getTextTemplates = function getTextTemplates() {
    var buttons = [];
    buttons.push({
      label: "Обычный текст",
      name: "Tag",
      props: {
        tag: "div"
      },
      components: [{
        name: "Tag",
        props: {
          text: "Lorem Ipsum \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0439 \"\u0440\u044B\u0431\u043E\u0439\" \u0434\u043B\u044F \u0442\u0435\u043A\u0441\u0442\u043E\u0432 \u043D\u0430 \u043B\u0430\u0442\u0438\u043D\u0438\u0446\u0435 \u0441 \u043D\u0430\u0447\u0430\u043B\u0430 XVI \u0432\u0435\u043A\u0430. \u0412 \u0442\u043E \u0432\u0440\u0435\u043C\u044F \u043D\u0435\u043A\u0438\u0439 \u0431\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439 \u043F\u0435\u0447\u0430\u0442\u043D\u0438\u043A \u0441\u043E\u0437\u0434\u0430\u043B \u0431\u043E\u043B\u044C\u0448\u0443\u044E \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044E \u0440\u0430\u0437\u043C\u0435\u0440\u043E\u0432 \u0438 \u0444\u043E\u0440\u043C \u0448\u0440\u0438\u0444\u0442\u043E\u0432, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F Lorem Ipsum \u0434\u043B\u044F \u0440\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u043A\u0438 \u043E\u0431\u0440\u0430\u0437\u0446\u043E\u0432. Lorem Ipsum \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u0436\u0438\u043B \u0431\u0435\u0437 \u0437\u0430\u043C\u0435\u0442\u043D\u044B\u0445 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u043F\u044F\u0442\u044C \u0432\u0435\u043A\u043E\u0432, \u043D\u043E \u0438 \u043F\u0435\u0440\u0435\u0448\u0430\u0433\u043D\u0443\u043B \u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u0434\u0438\u0437\u0430\u0439\u043D."
        },
        components: []
      }]
    });
    buttons.push({
      label: "Средний текст",
      name: "Tag",
      props: {
        tag: "div",
        style: {
          fontSize: "1.5rem"
        }
      },
      components: [{
        name: "Tag",
        props: {
          text: "Lorem Ipsum \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0439 \"\u0440\u044B\u0431\u043E\u0439\" \u0434\u043B\u044F \u0442\u0435\u043A\u0441\u0442\u043E\u0432 \u043D\u0430 \u043B\u0430\u0442\u0438\u043D\u0438\u0446\u0435 \u0441 \u043D\u0430\u0447\u0430\u043B\u0430 XVI \u0432\u0435\u043A\u0430. \u0412 \u0442\u043E \u0432\u0440\u0435\u043C\u044F \u043D\u0435\u043A\u0438\u0439 \u0431\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439 \u043F\u0435\u0447\u0430\u0442\u043D\u0438\u043A \u0441\u043E\u0437\u0434\u0430\u043B \u0431\u043E\u043B\u044C\u0448\u0443\u044E \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044E \u0440\u0430\u0437\u043C\u0435\u0440\u043E\u0432 \u0438 \u0444\u043E\u0440\u043C \u0448\u0440\u0438\u0444\u0442\u043E\u0432, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F Lorem Ipsum \u0434\u043B\u044F \u0440\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u043A\u0438 \u043E\u0431\u0440\u0430\u0437\u0446\u043E\u0432. Lorem Ipsum \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u0436\u0438\u043B \u0431\u0435\u0437 \u0437\u0430\u043C\u0435\u0442\u043D\u044B\u0445 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u043F\u044F\u0442\u044C \u0432\u0435\u043A\u043E\u0432, \u043D\u043E \u0438 \u043F\u0435\u0440\u0435\u0448\u0430\u0433\u043D\u0443\u043B \u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u0434\u0438\u0437\u0430\u0439\u043D."
        },
        components: []
      }]
    });
    buttons.push({
      label: "Крупный текст",
      name: "Tag",
      props: {
        tag: "div",
        style: {
          fontSize: "2rem"
        }
      },
      components: [{
        name: "Tag",
        props: {
          text: "Lorem Ipsum \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0439 \"\u0440\u044B\u0431\u043E\u0439\" \u0434\u043B\u044F \u0442\u0435\u043A\u0441\u0442\u043E\u0432 \u043D\u0430 \u043B\u0430\u0442\u0438\u043D\u0438\u0446\u0435 \u0441 \u043D\u0430\u0447\u0430\u043B\u0430 XVI \u0432\u0435\u043A\u0430. \u0412 \u0442\u043E \u0432\u0440\u0435\u043C\u044F \u043D\u0435\u043A\u0438\u0439 \u0431\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439 \u043F\u0435\u0447\u0430\u0442\u043D\u0438\u043A \u0441\u043E\u0437\u0434\u0430\u043B \u0431\u043E\u043B\u044C\u0448\u0443\u044E \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044E \u0440\u0430\u0437\u043C\u0435\u0440\u043E\u0432 \u0438 \u0444\u043E\u0440\u043C \u0448\u0440\u0438\u0444\u0442\u043E\u0432, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F Lorem Ipsum \u0434\u043B\u044F \u0440\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u043A\u0438 \u043E\u0431\u0440\u0430\u0437\u0446\u043E\u0432. Lorem Ipsum \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u0436\u0438\u043B \u0431\u0435\u0437 \u0437\u0430\u043C\u0435\u0442\u043D\u044B\u0445 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u043F\u044F\u0442\u044C \u0432\u0435\u043A\u043E\u0432, \u043D\u043E \u0438 \u043F\u0435\u0440\u0435\u0448\u0430\u0433\u043D\u0443\u043B \u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u0434\u0438\u0437\u0430\u0439\u043D."
        },
        components: []
      }]
    });
    return buttons;
  };

  FrontEditor.prototype.getMenuTemplates = function getMenuTemplates() {
    var buttons = [];
    buttons.push({
      label: "Главное меню",
      name: "PageHeader",
      props: {},
      components: []
    });
    return buttons;
  };

  FrontEditor.prototype.getDataTemplates = function getDataTemplates() {
    var buttons = [];
    buttons.push({
      label: "Пользователи",
      name: "Section",
      props: {},
      components: [{
        "name": "Connector",
        "props": {
          "first": 12,
          "filtersname": "filters",
          query: "usersConnection"
        },
        "components": [{
          "name": "Grid",
          "props": {
            "container": true,
            "spacing": 8
          },
          "components": [{
            "name": "Grid",
            "props": {
              "item": true,
              "xs": 12
            },
            "components": [{
              "name": "Filters",
              props: {},
              "components": []
            }]
          }, {
            "name": "Grid",
            "props": {
              "item": true,
              "xs": 12
            },
            "components": [{
              "name": "ListView",
              props: {},
              "components": [{
                "name": "Grid",
                "props": {
                  "item": true,
                  "xs": 12,
                  "md": 6,
                  "xl": 3
                },
                "components": [{
                  "name": "UserLink",
                  "props": {},
                  "components": []
                }, {
                  "name": "NamedField",
                  "props": {
                    name: "fullname"
                  },
                  "components": []
                }]
              }]
            }]
          }, {
            "name": "Grid",
            "props": {
              "item": true,
              "xs": 12
            },
            "components": [{
              "name": "Pagination",
              props: {},
              components: []
            }]
          }]
        }]
      }]
    });
    return buttons;
  };

  FrontEditor.prototype.getMediaTemplates = function getMediaTemplates() {
    var buttons = [];
    buttons.push({
      label: "YouTube",
      name: "Section",
      props: {
        style: {
          height: 0,
          position: "relative",
          paddingTop: "56.25%",
          overflow: "hidden"
        }
      },
      components: [{
        name: "Tag",
        props: {
          tag: "iframe",
          src: "https://www.youtube.com/embed/4j9ePxDhHGU",
          frameborder: 0,
          allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
          allowFullScreen: true,
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            border: 0,
            width: "100%",
            height: "100%"
          }
        },
        components: []
      }]
    });
    return buttons;
  };

  FrontEditor.prototype.renderItems = function renderItems() {
    var _props5 = this.props,
        staticContext = _props5.staticContext,
        inEditMode = _props5.inEditMode,
        debug = _props5.debug,
        components = _props5.components,
        data = _props5.data,
        setPageMeta = _props5.setPageMeta,
        Components = _props5.Components,
        CustomComponents = _props5.CustomComponents,
        other = _objectWithoutProperties(_props5, ['staticContext', 'inEditMode', 'debug', 'components', 'data', 'setPageMeta', 'Components', 'CustomComponents']);

    var object = data && data.object || {};

    var _ref2 = object || {},
        name = _ref2.name,
        component = _ref2.component;

    if (!component) {
      return null;
    }

    var RenderComponents = this.getComponents(); // const Page = Components.find(n => n.Name === "Page");

    var Component = RenderComponents.find(function (n) {
      return n.Name === component;
    });

    if (!Component) {
      return null;
    }

    return _react2.default.createElement(Component, _extends({
      mode: 'main' // data={{
      //   object,
      // }}
      // data={data}
      ,
      object: object // _dirty={_dirty}
      // onSave={onSave}

    }, other));
  };

  FrontEditor.prototype.updateObject = function updateObject(data) {
    var components = data.components;
    var onChange = this.props.onChange;

    if (onChange && components !== undefined) {
      return onChange(components);
    }
  };

  FrontEditor.prototype.getComponents = function getComponents() {
    var Components = this.state.Components;
    return Components;
  };

  FrontEditor.prototype.renderToolbar = function renderToolbar() {
    var toolbar = this.props.toolbar;
    return toolbar ? toolbar : null;
  };

  FrontEditor.prototype.render = function render() {
    var _this6 = this;

    var _props6 = this.props,
        classes = _props6.classes,
        children = _props6.children,
        components = _props6.components,
        updateObject = _props6.updateObject,
        inEditMode = _props6.inEditMode,
        debug = _props6.debug,
        className = _props6.className;
    var _state3 = this.state,
        dragItem = _state3.dragItem,
        dragTarget = _state3.dragTarget,
        activeItem = _state3.activeItem,
        hoveredItem = _state3.hoveredItem,
        editorContext = _state3.editorContext;
    var settingsViewContainer = this.settingsViewContainer; // const Components = this.getComponents();

    var items = this.renderItems();
    return _react2.default.createElement(_context3.EditorContext.Provider, {
      value: editorContext
    }, inEditMode ? _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('div', {
      className: [classes.toolbar, classes.bordered].join(" ")
    }, this.renderToolbar()), _react2.default.createElement('div', {
      className: [classes.root, className].join(" ")
    }, this.renderTemplates(), _react2.default.createElement('div', {
      className: [classes.editor, classes.bordered].join(" "),
      style: {
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }
    }, _react2.default.createElement('div', {
      style: {
        flex: 1,
        overflow: "auto"
      }
    }, items), _react2.default.createElement('div', {
      ref: function ref(el) {
        _this6.actionPanel = el;
      },
      className: [classes.actionPanel, "front-editor--action-panel"].join(" ")
    })), _react2.default.createElement('div', {
      className: [classes.panel, classes.bordered, "opened"].join(" ")
    }, this.renderPanels()))) : items);
  };

  return FrontEditor;
}(_react.Component), _class.contextType = _context2.default, _class.defaultProps = {
  debug: false,
  Components: [_Grid2.default, _Section2.default, _Typography2.default, _Tag2.default, // TextArea,
  _Query2.default, _Connector2.default, _ObjectConnector2.default, _ListView2.default, _Iterable2.default, _ObjectView2.default, _Pagination2.default, _NamedField2.default, _DefaultValue2.default, _RichText2.default, _ObjectImage2.default, _FileUploader2.default, _UserLink2.default, _CurrentUser2.default, _Filters2.default, _CreateObjectLink2.default, _SudoOnly2.default, _CreatedBy2.default, _Content2.default, _Link2.default, _Button2.default, _Switch2.default, _Route2.default, _PageHeader2.default, _AppBar2.default, _Login2.default, // ChangeLanguage,
  _LanguageRouter2.default, _Slider2.default, // UsersGrid,
  // UserPage,
  // RoutedObject,
  // ParralaxTest,
  // DraftEditor,
  _EditableObject2.default, _EditableView2.default, _DefaultView2.default, _EditableObjectButtons2.default, _ResetObjectContext2.default, _TextField2.default, _VerticalTimeline2.default, _VerticalTimelineItem2.default, _Table2.default, _TableRow2.default, _TableCell2.default, _Tabs2.default, _Tab2.default],
  CustomComponents: [],
  className: "fullheight",
  templates: []
}, _temp);
FrontEditor.propTypes = process.env.NODE_ENV !== "production" ? {
  debug: _propTypes2.default.bool.isRequired,
  classes: _propTypes2.default.object.isRequired,
  // onDrop: PropTypes.func.isRequired,
  onChange: _propTypes2.default.func,
  components: _propTypes2.default.array,
  Components: _propTypes2.default.arrayOf(_propTypes2.default.func).isRequired,
  CustomComponents: _propTypes2.default.arrayOf(_propTypes2.default.func).isRequired,
  toolbar: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.func]),
  className: _propTypes2.default.string,
  templates: _propTypes2.default.array
} : {};
var FrontEditorRenderer = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(FrontEditor, props);
});
exports.default = FrontEditorRenderer;
module.exports = exports['default'];